export const DEFAULT_PRINTING_SETTINGS = {
  printingEnabled: false,
  printingMode: 'browser',
  printerServerUrl: '',
  printerIp: '',
  printerPort: 9100,
  autoPrintSales: true,
  autoPrintKitchen: true,
  fallbackToBrowserPrint: true,
  paperWidth: 80,
  printerName: '',
};

export function normalizePrintSettings(printing = {}) {
  return {
    ...DEFAULT_PRINTING_SETTINGS,
    ...(printing || {}),
    printerPort:
      Number(printing?.printerPort ?? DEFAULT_PRINTING_SETTINGS.printerPort) ||
      DEFAULT_PRINTING_SETTINGS.printerPort,
    paperWidth:
      Number(printing?.paperWidth ?? DEFAULT_PRINTING_SETTINGS.paperWidth) === 58 ? 58 : 80,
    printingEnabled: Boolean(printing?.printingEnabled),
    autoPrintSales: printing?.autoPrintSales ?? DEFAULT_PRINTING_SETTINGS.autoPrintSales,
    autoPrintKitchen: printing?.autoPrintKitchen ?? DEFAULT_PRINTING_SETTINGS.autoPrintKitchen,
    fallbackToBrowserPrint:
      printing?.fallbackToBrowserPrint ?? DEFAULT_PRINTING_SETTINGS.fallbackToBrowserPrint,
    printingMode: printing?.printingMode === 'server' ? 'server' : 'browser',
    printerServerUrl: String(printing?.printerServerUrl || '').trim(),
    printerIp: String(printing?.printerIp || '').trim(),
    printerName: String(printing?.printerName || '').trim(),
  };
}

export function normalizePrintingSettings(printing = {}) {
  return normalizePrintSettings(printing);
}

export function normalizeSettings(settings = {}) {
  return {
    ...settings,
    printing: normalizePrintSettings(settings?.printing),
  };
}
